<template>
<svg viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.94043 12.28L5.2871 7.9333C5.80043 7.41997 5.80043 6.57997 5.2871 6.06664L0.94043 1.71997" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
</svg></template>